var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c("div", { staticClass: "flex flex-col gap-1" }, [
        _c("p", { staticClass: "opacity-50" }, [
          _vm._v(_vm._s(_vm.labelText) + ":"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex gap-2" },
          _vm._l(_vm.optionGroups, function (group) {
            return _c(
              "label",
              {
                key: group.id,
                staticClass:
                  "input-room-wrapp relative px-4 py-2 cursor-pointer select-none",
              },
              [
                _c("input", {
                  staticClass: "absolute left-[-99999px] opacity-0 peer",
                  attrs: { type: "checkbox", name: _vm.name },
                  domProps: { checked: _vm.selectedGroups.includes(group) },
                  on: {
                    input: function ($event) {
                      return _vm.handleInput(group)
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "input-room-border absolute inset-0 bg-white input-border duration-200 peer-checked:bg-blue",
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "relative z-10 duration-200 peer-checked:text-white",
                  },
                  [_vm._v(_vm._s(group.text))]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }